import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const fileS3UrlRepository = RepositoryFactory.get("fileS3Url");
const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setFileS3Url(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadFileS3Url(context, payload) {
    const list = await fileS3UrlRepository.create(
      payload.screenId,
      payload.s3objects,
      payload.bucketName
    );
    if (list.status < 300) {
      context.commit("setFileS3Url", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
